module.exports = __webpack_public_path__ + "img/lock.ba2d4639.svg";